export default __webpack_public_path__ + "static/media/11.2c0f11a7.webp";